export const VIEW_TYPES = {
  MONTH: 'month',
  WEEK: 'week',
};

export const VIEW_TYPES_TEXT = {
  [VIEW_TYPES.MONTH]: 'Месяц',
  [VIEW_TYPES.WEEK]: 'Неделя',
};
